<template>
  <br />
  <div v-if="cargando" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2">Cargando póliza...</p>
  </div>
  <div v-else-if="errorCarga" class="alert alert-danger mx-3">
    {{ errorCarga }}
  </div>
  <SimpleWizard v-else />
</template>

<script>
import api from '@/axios';
import { useSeguroStore } from '@/stores/seguroStore';
import SimpleWizard from './wizardNuevoSeguro.vue';

export default {
  name: 'detallePolizaExistente',
  components: { SimpleWizard },
  setup() {
    const store = useSeguroStore();
    return { store };
  },
  data() {
    return {
      cargando: false,
      errorCarga: null,
    };
  },
  mounted() {
    this.cargarPoliza();
  },
  methods: {
    async cargarPoliza() {
      const id = this.$route.params.id;
      if (!id) return;

      this.cargando = true;
      this.errorCarga = null;
      this.store.resetContratante();

      try {
        const response = await api.get(`wizard/poliza/${id}`);
        this.store.loadFromDto(response.data);
      } catch (err) {
        this.errorCarga = err?.response?.data?.message
          || `No se pudo cargar la póliza con id ${id}.`;
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>
